import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sms-consent',
  templateUrl: './sms-consent.component.html',
  styleUrls: ['./sms-consent.component.scss']
})
export class SmsConsentComponent implements OnInit {
  phone = '';
  smsConsent = false;
  submitting = false;
  submitted = false;

  phoneError = '';
  consentError = '';
  constructor() { }

  ngOnInit(): void {
  }
  private validatePhone(value: string): boolean {
    const stripped = value.replace(/[\s\-().+]/g, '');
    return /^\d{7,15}$/.test(stripped);
  }

  onSubmit(): void {
    this.phoneError = '';
    this.consentError = '';
    this.submitted = false;

    let valid = true;

    if (!this.validatePhone(this.phone)) {
      this.phoneError = 'Please enter a valid phone number.';
      valid = false;
    }

    if (!this.smsConsent) {
      this.consentError = 'You must agree to receive SMS messages to continue.';
      valid = false;
    }

    if (!valid) { return; }

    this.submitting = true;

    // כאן תחבר את ה-API שלך
    setTimeout(() => {
      this.submitting = false;
      this.submitted = true;
    }, 1200);
  }

  onPhoneChange(): void {
    if (this.phoneError && this.validatePhone(this.phone)) {
      this.phoneError = '';
    }
  }

  onConsentChange(): void {
    if (this.smsConsent) {
      this.consentError = '';
    }
  }

}